module.exports = __webpack_public_path__ + "img/logo-osf-login-web.81d8f45a.png";